import { render, staticRenderFns } from "./medicalWaste.vue?vue&type=template&id=2f3c5f9c&scoped=true&"
import script from "./medicalWaste.vue?vue&type=script&lang=js&"
export * from "./medicalWaste.vue?vue&type=script&lang=js&"
import style0 from "./medicalWaste.vue?vue&type=style&index=0&id=2f3c5f9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c5f9c",
  null
  
)

export default component.exports